import $ from 'jquery';
require('slick-carousel');
require('slick-carousel/slick/slick.css');


let app = app || {};
let deviceFlg = 'pc';
let _window = $(window);
let changeCurrent = -1;

$(function() {

  //ブラウザの「戻るボタン」で来た時対応
  if($('body').hasClass('page-index')){
    $('body,html').animate({scrollTop: $(window).scrollTop() + 1 }, 1, 'swing');
  }

  let ua = navigator.userAgent;
  if (ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
    deviceFlg = 'sp';
  } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
    $('[name="viewport"]').attr('content','width=1200');
    $('body').addClass('deviceTablet');
    deviceFlg = 'tablet';
    $('.topMovie').append('<source src="assets/mov/index.mp4">');
  } else {
    deviceFlg = 'pc';
    $('.topMovie').append('<source src="assets/mov/index.mp4">');
  }
	_window.on("load resize", function(){
    if($(this).width() <= 768){
      $('body').addClass('tab-sp');
    }else{
      $('body').removeClass('tab-sp');
    }
  });

  
  app.init = function() {
    app.scrollFadeInElms = [];
    app.paginationTarget = [];
    app.scrollEvent();
    app.pageLink();
    app.modal();
    // app.loader();
    app.menuTrigger();
    $('.js-scroll-action').each(function(index, el) {
      app.scrollFadeInElms.push($(this).offset().top);
    });
    $('[id^="sec"]').each(function(index, el) {
      app.paginationTarget.push($(this).offset().top);
    });

    _window.on("resize", function(){
      app.scrollFadeInElms = [];
      app.paginationTarget = [];
      setTimeout(() => {
        $('.js-scroll-action').each(function(index, el) {
        app.scrollFadeInElms.push($(this).offset().top);
      });
      $('[id^="sec"]').each(function(index, el) {
        app.paginationTarget.push($(this).offset().top);
      });
      }, 1);
    });

	}

	app.sleep = function(ms) {
    return new Promise((resolve,reject) => {
      setTimeout(resolve, ms);
    });
  }

  app.loader = function() {
    // $(window).on('load',function(){
    //   $("#page-loading").delay(1000).fadeOut('slow');
    // });
    setTimeout(function() {
      $("#page-loading").delay(1000).fadeOut('slow');
    }, 1000);

    // function loaderClose(){
    //   $("#page-loading").fadeOut('slow');
    // }
    // setTimeout(loaderClose,10000);
  }

  //scrollイベントの親
  app.scrollEvent = function() {
  	let self = this;
  	_window.on("scroll", function() {
  		let winS = _window.scrollTop();
      self.pageTop(winS);
      self.scrollFadeIn(winS);
      self.pagination(winS);
  	});
  }

  app.pageLink = function() {
    $('a[href^="#"]').on("click", function(e) {
      let speed = 1000;
      let href= $(this).attr("href");
      let target = $(href == "#" || href == "" ? 'html' : href);
      let position = target.offset().top - 70;
      if(href == "#catFukusyoku"){
        speed = 400;
      }
      if(href == "#top" && !$(this).hasClass('is-pageTop')){
        $('body,html').animate({scrollTop:$(window).height()}, speed, 'swing');
      }else{
        $('body,html').animate({scrollTop:position}, speed, 'swing');
      }
      return false;
    });
  }

  app.scrollFadeIn = function( winS ) {
    let self = this;
    let buffer = 100;
    if(deviceFlg == 'sp') buffer = 200;
  	self.scrollFadeInElms.forEach((item, index) => {
      if( winS > item - (_window.height() / 2 ) - buffer){
        if($('.js-scroll-action').eq(index).data('fadein-order') && deviceFlg == 'pc'){
          let order = $('.js-scroll-action').eq(index).data('fadein-order');
          setTimeout(() => {
            $('.js-scroll-action').eq(index).addClass('is-over');
          }, order * 200);
        }else{
          $('.js-scroll-action').eq(index).addClass('is-over');
        }
      }
    })
  }

  app.pagination = function( winS ) {
    let self = this;
    
    function changeNavCurrent(curNum){
      if (curNum != changeCurrent || curNum == 0) {
        changeCurrent = curNum;
        $('#pagination span').removeClass('current');
        $('#pagination span').eq(curNum).addClass('current');  
      }
    }

    for (let i = self.paginationTarget.length - 1; i >= 0; i--) {
      if(winS > self.paginationTarget[i] - (_window.height() / 2)){
        changeNavCurrent(i);
        break;
      }
    };

    if(winS < $('#lead').offset().top){
      $('#pagination span').removeClass('current');
    }

  }

  app.pageTop = function( winS ) {
    if( winS < 200){
      $('.pageTop').removeClass('is-hide is-pageTop');
      $('#pageTop-icon').attr("src",$("#pageTop-icon").attr('src').replace('_on', '_off'));
    }
    if( winS > 200){
      $('.pageTop').addClass('is-hide');
    }
    if( winS > 1000){
      $('.pageTop').addClass('is-pageTop');
      $('#pageTop-icon').attr("src",$("#pageTop-icon").attr('src').replace('_off', '_on'));
    }
  }

  app.modal = function() {
    $('[data-modal-open]').on('click',function(e){
      e.preventDefault();
      let modalType = $(this).attr('data-modal-open');
      $('[data-modal-body='+ modalType + ']').show();
      $('.modalWrapper').fadeIn();
    });
    $('.modalClose, .modalWrapper').on('click',function(){
      $('[data-modal-body]').hide();
      $('.modalWrapper').fadeOut();
    });
  }
  
  app.menuTrigger = function(){
    $('.menu-trigger').on('click',function(e){
      e.preventDefault();
      $(this).toggleClass('is-active');
      $('.triggerArea').slideToggle();
    });
    $('#pagination a').on('click',function(){
      $('.menu-trigger').removeClass('is-active');
      $('.tab-sp .triggerArea').hide();
    });
  }



	app.init();

});


// WEBPACK FOOTER //
// ./src/js/app.js